/*!
 * search-custom.js
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */

var hotels = []
var currentHotel = {}

async function fetchHotels() {
  const response = await fetch('/TenN/theme/assets/api/hotels/index.json');
  const data = await response.json();
  return data;
}

async function setCurrentHotel({ hotels = [], slug = '' }) {
  // Set default `currentHotel` as the `code` of first hotels item
  currentHotel = hotels[0];
  // If `slug` is not specified, use pathname to find the `code` of the hotel it is located in
  let definedSlug = slug || window.location.pathname;
  // Find the hotel that includes the `slug` and set the `currentHotel` with the `hotel.code`
  for await(const hotel of hotels) { if(definedSlug.includes(hotel.slug)) { currentHotel = hotel; break; } }
  return currentHotel;
}

function dispatchCurrentHotelReadyEvent(detail) {
  document.dispatchEvent(new CustomEvent('currentHotel', { detail }));
}

// Ensure that `hotels` array is filled before calling `setCurrentHotel` function
async function setHotelInfo() {
  hotels = await fetchHotels(); // Fill the `hotels` array asynchronously
  currentHotel = await setCurrentHotel({ hotels })
  dispatchCurrentHotelReadyEvent(currentHotel)
}

setHotelInfo(); // Call the initialization function

var searchBox = document.querySelector('.search-box');
var roomImageSliders = [];
var availableAirports = [];

// Flight Popup input autocomplete codes.
var cultureName = 'en';
var url = window.location.href;
if (url.indexOf('/tr/') > 0) cultureName = 'tr';
else if (url.indexOf('/en/') > 0) cultureName = 'en';
if (url.indexOf('/de/') > 0) cultureName = 'en';
if (url.indexOf('/ru/') > 0) cultureName = 'ru';

function UISliderInit() {
  $('[data-uislider]').each(function () {
    var $this = $(this);
    var lang = $('html').attr('lang');

    var initialValues = [0, 1440];

    function getTime(value) {
      var hours = Math.floor(value / 60);
      var minutes = value - hours * 60;

      if (hours.length == 1) hours = '0' + hours;
      if (minutes.length == 1) minutes = '0' + minutes;
      if (minutes == 0) minutes = '00';

      if (lang != 'tr') {
        if (hours >= 12) {
          if (hours == 12) {
            hours = hours;
            minutes = minutes + ' PM';
          } else {
            hours = hours - 12;
            minutes = minutes + ' PM';
          }
        } else {
          hours = hours;
          minutes = minutes + ' AM';
        }
        if (hours == 0) {
          hours = 12;
          minutes = minutes;
        }
      }

      return hours + ':' + minutes;
    }

    $this.slider({
      range: true,
      min: 0,
      max: 1440,
      step: 15,
      values: initialValues,
      create: function (e, i) {
        var min = initialValues[0];
        var max = initialValues[1];

        $this
          .parent()
          .find('.from-time')
          .text(getTime(min) + ' - ' + getTime(max));
      },
      slide: function (event, ui) {
        var min = ui.values[0];
        var max = ui.values[1];

        $this
          .parent()
          .find('.from-time')
          .text(getTime(min) + ' - ' + getTime(max));
      },
      change: function (event, ui) {
        var minTime = ui.values[0];
        var maxTime = ui.values[1];
        var filterType = $(this).data('flightfilter-filtertype');
        var filter = filterTypes.find(x => x.name == filterType);
        if (filter != undefined) {
          filter.filterValues[0].min = minTime;
          filter.filterValues[0].max = maxTime;
          getFilters();
          filterResults();
        }
        takeFirstFive('departure', false);
        takeFirstFive('return', false);
        window.takeFirstFive('package', false);
      },
    });
  });
}

function checkModernInput() {
  $('.fake-placeholder').each(function () {
    $('input.form-control,textarea.form-control').each(function () {
      if ($(this).val() != '') {
        $(this).closest('.fake-placeholder').addClass('focused');
      } else {
        $(this).closest('.fake-placeholder').removeClass('focused');
      }
    });
  });

  $('.fake-placeholder').each(function () {
    var $this = $(this),
      $inpElem = $this.find('input,textarea');

    $this.parent().addClass('pt-3');
    $this.parent().siblings('[class*=col]').addClass('pt-3');

    $inpElem.on('focus', function () {
      $this.addClass('focused');
    });

    $inpElem.on('blur', function () {
      var isValid = $(this).val() == '' ? true : false;
      isValid === true ? $this.removeClass('focused') : $this.addClass('focused');
    });
  });
}

var fakeplaceholderInit = () => {
  $('.fake-placeholder').each(function () {
    var $this = $(this);
    var $input = $(this).find('input,textarea');

    if ($input.val() != '') $this.addClass('focused');

    $input.on({
      focus: function () {
        $this.addClass('focused');
      },
      focusout: function () {
        if ($input.val() == '') $this.removeClass('focused');
      },
    });
  });
};

const contactUsDataLayerTrigger = () => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ 'event': 'form_submit', 'campaign_id': 'sizi_arayalim' });
  console.log('Data layer triggered');
};

function focus() { [].forEach.call(this.options, function (o) { o.textContent = o.getAttribute('data-country') + ' (' + o.getAttribute('value') + ')'; }); }
function blur() { [].forEach.call(this.options, function (o) { o.textContent = '(' + o.getAttribute('value') + ')'; }); }

const scrollToInvalid = _elem => {
  var elem;
  if (_elem && _elem instanceof HTMLElement) elem = _elem;
  else { elem = document.querySelector(_elem || '.input-validation-error'); }
  if (elem) { elem.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
};

function CloseResponseModel() { $('#responseModal').modal('toggle'); }

const showSuccessModal = (formData) => {
  $('#responseModal .modal-title').addClass('d-none');
  $('#responseModal .modal-title.success').removeClass('d-none');
  $('#responseModal').modal('show');
  $('#responseModal').show();
  $('#responseSuccess').removeClass('d-none');
  $('#responseFail').addClass('d-none');
  
  /* Show content based on `RequestReason` in `#responseSuccess` */
  $('#responseSuccess .modal-description [class*="modal-description--"]').hide()
  if(formData.RequestReason=="3"){
    $('#responseSuccess .modal-description .modal-description--RequestReason').show()
    /* fix(callReqForm.reset): reset RequestReason */
    btnRequestReasonTrigger.dispatchEvent(new Event('change'));
  } else {
    $('#responseSuccess .modal-description .modal-description--CallHours').show()
  }
};

const showErrorModal = () => {
  $('#responseModal').addClass('show');
  $('#responseModal').modal('show');
  $('#responseModal').show();
  $('#responseSuccess').addClass('d-none');
  $('#responseFail').removeClass('d-none');
};

function FillAvailableAirports(keyword) {
  $.ajax({ type: 'GET', url: '/' + cultureName + '/book-FlightAirportSearch/' + keyword, dataType: 'json', })
  .done(function (data) { var list = data; $.each(list, function (index, item) { availableAirports.push(item); }); })
  .fail(function (xhr) { console.log(xhr.responseText); });
}
const sameDaysSelected = () => { return $('#inpCheckinDate').val() == $('#inpCheckoutDate').val(); };

const validateChildAges = () => {
  var isValid = true;
  var t = this;
  $('[id*=selectChild]:visible').each(function (i, e) {
    if (!e || e.value == '') {
      e.classList.add('is-invalid');
      e.classList.remove('is-valid');
      t.event.stopPropagation();
      return false;
    } else {
      e.classList.add('is-valid');
      e.classList.remove('is-invalid');
      isValid = true;
    }
  });
  return isValid;
};

var siteKey = '6LeaTy0aAAAAAKhWr2p-semNWLssT-j_pQv0QLY_';
var renderRecaptcha = function () {
  grecaptcha.render('ReCaptchContainer', {
    sitekey: siteKey,
    // callback: function(response) {
    //     console.log(response);
    // },
    theme: 'light', //light or dark
    size: 'normal', //normal or compact
    type: 'image', // image or audio
  });
};

function OnlyLetter(key) {
  var char = String.fromCharCode(key.which);
  if (/[.,\/#!$%\^&\*;:{}=\-_`~()<>0-9]/g.test(char)) { key.preventDefault(); }
}

$('#callYouModal').on('shown.bs.modal', function () { $('#voyageMembersModal').modal('hide'); });

$('.reservation-details-total .trigger').on('click', function (e) {
  var ww = $(window).width();
  e.preventDefault();
  if (ww < 1280) { $(this).closest('.reservation-details').toggleClass('is-shown'); $('body').toggleClass('no-scroll-body'); }
});

$('.btnEditSearch').on('click', function () {
  var $searchBox = $(this).closest('.search-box');
  $searchBox.toggleClass('expanded');
  $('html,body').animate({ scrollTop: $searchBox.offset().top - 100, }, 750,);
});

$('.btn--view').each(function () {
  $(this).on('click', function () {
    var hasIsShown = $(this).closest('.room-item').hasClass('is-shown');

    if (hasIsShown) { $(this).closest('.room-item').removeClass('is-shown'); } else {
      $('.room-item').removeClass('is-shown');

      var $roomItem = $(this).closest('.room-item');
      var roomItemTop = $(this).closest('.room-item').offset().top - 100;
      var topAmount = $(this).offset().top - 100;

      $('html,body').animate({ scrollTop: $roomItem.hasClass('is-shown') ? roomItemTop : topAmount, }, 750,);

      $(this).closest('.room-item').toggleClass('is-shown');
    }
  });
});

$('.room-item').each(function () {
  $(this)
    .find('.room-image-slider')
    .each(function (idx, el) {
      var config = {
        slidesPerView: 1,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        loop: true,
        containerModifierClass: 'room-image-slider',
        wrapperClass: 'room-image-wrapper',
        slideClass: 'room-image-slide',
        slideActiveClass: 'room-image-slide--active',
        slideNextClass: 'room-image-slide--next',
        slidePrevClass: 'room-image-slide--prev',
        pagination: {
          el: this.querySelector('[class*=slider-pagination]'),
          bulletClass: 'slider-pagination-bullet',
          bulletActiveClass: 'slider-pagination-bullet--active',
          currentClass: 'slider-pagination-bullet--current',
          hiddenClass: 'slider-pagination-bullet--hidden',
          clickable: true,
        },
        navigation: { prevEl: '.slider-icons.slider-icons--prev', nextEl: '.slider-icons.slider-icons--next', },
        lazy: { elementClass: 'lazy', loadPrevNext: true, loadedClass: 'lazy-loaded', },
        breakpoints: { 767.99: { slidesPerView: 3, }, 1279.99: { slidesPerView: 4, }, },
      };

      roomImageSliders[idx] = new Swiper($(this), config);
    });
});

$('.no-transfer-inputs').each(function () {
  $(this).on('click', function () {
    $(this).closest('.transfers__list').toggleClass('not-visible');
    if ($(this).hasClass('checked')) { $(this).removeClass('checked'); } else { $(this).addClass('checked'); }
  });
});

$('[name*=-transfers]').each(function () {
  $(this).on('change', function () { $(this).closest('.transfers__list').addClass('is-shown'); });
});

$('.search-details [class*=--filters]').on('click', function (e) {
  e.preventDefault();
  if ($(window).outerWidth() < 1280) { $('.flight-filter').toggleClass('is-shown'); }
});

UISliderInit();

$('.flight-block').each(function () {
  var $this = $(this);
  var isPackageItems = $this.hasClass('flight-block--package');

  var $flightItem = $this.find('.flight-item');
  var maxLength = isPackageItems ? 2 : 4;

  var moreFlightButtonItem = '<div class="text-center mt-3"><a href="#!" class="btn btn--more-flight show-more"><span class="more">Daha Fazla Uçuş</span><span class="less">Daha Az Uçuş</span></a></div>';

  if ($flightItem.length > maxLength) { $(moreFlightButtonItem).insertAfter($this); }

  $this.find('.flight-item:lt(' + maxLength + ') ').fadeIn();
});

$('.btn--more-flight').on('click', function (e) {
  e.preventDefault();
  var $this = $(this);

  var $flightBlock = $this.parent().prev();

  var isPackage = $flightBlock.hasClass('flight-block--package');
  var max = isPackage ? 2 : 4;
  var hiddenLength = $flightBlock.find('.flight-item:hidden').length;

  if (hiddenLength == 0) {
    $flightBlock.find('.flight-item').removeAttr('style');
    $flightBlock.find('.flight-item:hidden:lt(' + max + ')').fadeIn();
  } else {
    $flightBlock.find('.flight-item:hidden:lt(' + max + ')').fadeIn();
  }

  var lastOffset = $flightBlock.find('.flight-item:visible:last').offset().top;

  $('html,body').animate({ scrollTop: lastOffset > 2000 ? lastOffset / 1.375 : lastOffset / 2, }, 1000,);

  if ($flightBlock.find('.flight-item:hidden').length == 0) { $this.removeClass('show-more'); } else { $this.addClass('show-more'); }
});

$('.bg-plus-circle').on('click', function () { $(this).toggleClass('is-shown'); });

$('[name="PaymentType"]').on('change', function () {
  var paymentMehtod = $(this).attr('id').replace('inp', '');

  var cssClass = 'is-shown';

  $('[data-payment-method]').removeClass(cssClass);
  $('[data-payment-method=' + paymentMehtod + ']').addClass(cssClass);
});

$('.steps-list').each(function () {
  var $stepList = $(this);
  var searchStep = window.location.pathname.split('/')[2];

  if (searchStep.includes('rooms')) {
    $stepList.find('[data-step="rooms"]').addClass('active');
  } else if (searchStep.includes('flight')) {
    $stepList.find('[data-step="flight"]').prevAll().addClass('past');
    $stepList.find('[data-step="flight"]').addClass('active');
  } else if (searchStep.includes('transfer')) {
    $stepList.find('[data-step="transfer"]').prevAll().addClass('past');
    $stepList.find('[data-step="transfer"]').addClass('active');
  } else if (searchStep.includes('guest')) {
    $stepList.find('[data-step="guests"]').prevAll().addClass('past');
    $stepList.find('[data-step="guests"]').addClass('active');
  } else if (searchStep.includes('checkout')) {
    $stepList.find('[data-step="checkout"]').prevAll().addClass('past');
    $stepList.find('[data-step="checkout"]').addClass('active');
  }
});

$('#chkFlightSelect').change(function () { $(this).is(':checked') ? $('#flightModal').modal('show') : ''; });

$('[flight-autocomplete]').each(function () {
  var $this = $(this);
  $this.autocomplete({
    source: function (request, response) {
      $.ajax({
        type: 'GET',
        url: '/' + cultureName + '/book-FlightAirportSearch/',
        dataType: 'json',
        data: { keyword: request.term },
        success: function (data) { response(data); },
        error: function (a, b, c) {},
      });
    },
    appendTo: $this.parent(),
    autoFill: false,
    matchCase: true,
    selectFirst: false,
  });
});

$('#btnContinue').on('click', function () {
  $('[class*=search-details--]:not(.d-none)').next().removeClass('d-none');

  var count = $('[class*=search-details--]:not(.d-none)').length - 1;

  $('[class*=search-details--]:not(.d-none)').each(function (idx) {
    if (idx < count) { $(this).addClass('d-none'); }
  });
});

$('.hotelTitle').html($('#selectHotel option:selected').text());
$('#spnFlightName').html($('#inpSelectAirportSource').val());

checkModernInput();

$('.room-item--offer').each(function () {
  $(this)
    .find('.btn.btn--default-white')
    .on('click', function () {
      var $roomItem = $(this).closest('.room-item--offer');
      var hasIsShown = $roomItem.hasClass('is-shown');

      hasIsShown ? $roomItem.toggleClass('is-shown') : $roomItem.addClass('is-shown');
    });
});

// #region BOOK CALENDAR
var selectedRoomId = localStorage.getItem('selectedRoomId');
if (selectedRoomId != null) {
  document.getElementById('inpRoomId').value = selectedRoomId;
}
$('#selectHotel').find('option').first().css('display', 'none');

$('base-datepickers').on("click", function () {
  document.querySelectorAll('#btnAdultBoxTrigger,#btnAdultBoxTrigger~div').forEach(x => { x.classList.remove('show'); });
});

$('#btnAdultBoxTrigger').on("click", function () { $('#base-datepickers').data('dateRangePicker').close(); });

$('.checkAvailablity').on("click", function () {
  var errors = [];
  $('[data-calendar="datepicker"]').each(function (ix, el) {
    var isShowing = $(this).closest('[data-child-col]').hasClass('active');
    if (isShowing) {
      var value = $(this).siblings('input[type="hidden"]').val();
      if (value == '1.01.0001 00:00:00' || value == '') { $(this).addClass('input-validation-error'); errors.push($(this)); } else { $(this).removeClass('input-validation-error'); }
    }
  });
  if (errors.length == 0) {
    $('#searchForm').validate();
    $('#searchForm').submit();
  }
});

$('#btnSearchRoom').on("click", function (evt) {
  var selectedhotelId = document.getElementById('inpHotelId').value;
  if (selectedhotelId !== null && selectedhotelId > 0) {
    if (sameDaysSelected()) {
      evt.stopPropagation();
      $('#base-datepickers').data('dateRangePicker').open();
      $('.dropdown.adult-box').removeClass('show');
    } else if (!validateChildAges()) {
      evt.stopPropagation();
      $('#btnAdultBoxTrigger').dropdown('toggle');
    } else {
      $('#searchForm').validate();
      $('#searchForm').submit();
    }
  } else {
    evt.stopPropagation();
    $('#hotelSelectddl').dropdown('toggle');
  }
});

$('#inpHasFlight').each(function () { var $this = $(this); $this.change(function () { $('#flightModal').modal('show'); }); });

//#region Deprecated Feature Fix - Use `MutationObserver` instead of `DOMSubtreeModified`

/** [Deprecation] Listener added for a synchronous 'DOMSubtreeModified' DOM Mutation Event.
 * 	This event type is deprecated (https://w3c.github.io/uievents/#legacy-event-types) and work is underway to remove it from this browser.
 * 	Usage of this event listener will cause performance issues today, and represents a risk of future incompatibility.
 * 	Consider using MutationObserver instead.
 */

// Create a MutationObserver for #adultCount
var adultCountObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    // Code to run when a DOM change occurs for #adultCount
    var thisValue = $(mutation.target).text().trim();
    $('#adultCountText').text(thisValue);
    $('#inpAdultCount').val(thisValue);
  });
});

// Create a MutationObserver for #childCount
var childCountObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    // Code to run when a DOM change occurs for #childCount
    var thisValue = $(mutation.target).text().trim();
    $('#childCountText').text(thisValue);
    $('#inpChildCount').val(thisValue);
  });
});

// Observe changes for #adultCount and #childCount
adultCountObserver.observe(document.getElementById('adultCount'), { childList: true });
childCountObserver.observe(document.getElementById('childCount'), { childList: true });
//#endregion

$('#inpHotelId').change(function (event) {
  $('#base-datepickers').data('dateRangePicker').open();
  event.preventDefault();
  event.stopPropagation();
});

const setChildCount = hotelValue => {
  if (hotelValue == '10') {
    var count = parseInt($('#childCount.count').text());
    for (let index = 0; index < count; index++) { $('.child-block .btn.btn--minus').click(); }
    $('.minus-plus.child-block').addClass('d-none');
  } else { $('.minus-plus.child-block').removeClass('d-none'); }
};

const checkAndHidePrePaymentText = hotelId => {
  var messageDiv = document.getElementById('prePaymentMessage');
  if (messageDiv) {
    // if (Number(hotelId) == 9 || Number(hotelId) == 10) {
    messageDiv.style.display = 'block';
    // } else messageDiv.style.display = 'none';
  }
};

var selectedHotelId = $('#inpHotelId').val();
checkAndHidePrePaymentText(selectedHotelId);
document.querySelectorAll('.hotelId-item').forEach(x => {
  var hotelValue = x.dataset.value;
  var hotelIdInput = document.getElementById('inpHotelId');
  x.addEventListener('click', function (event) {
    hotelIdInput.value = hotelValue;
    //checkAndHidePrePaymentText(hotelValue);
    localStorage.setItem('selectedHotelId', hotelValue);
    event.stopPropagation();
    hotelIdInput.dispatchEvent(new Event('change'));
    $('#hotelSelectddl').dropdown('toggle');
    setChildCount(hotelValue);
  });
  if (hotelValue == hotelIdInput.value) { document.getElementById('hotelSelectddl').innerText = x.text; }
});

setChildCount(selectedHotelId);

$('#base-datepickers').bind('datepicker-closed', function () { $('#btnAdultBoxTrigger').dropdown('toggle'); });

$('header').before($('#flightModal'));
// #endregion BOOK CALENDAR

// #region FORMS
function validateForm(elem) {
  var elemID = elem.id;
  var recaptcha = document.forms[elemID]['g-recaptcha-response'].value;
  if (recaptcha == '') { document.querySelectorAll('.g-recaptcha').forEach(function (e) { e.style.border = 'solid 1px red'; }); return false; }
  else { document.querySelectorAll('.g-recaptcha').forEach(function (e) { e.style.border = ''; }); return true; }
}

function postToCrm(formData, formId) {
  if (validateForm({ id: formId })) {
    $.ajax({
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded; charset=utf-8',
      url: '/tr/book-SaveCallRequest',
      data: formData,
      crossDomain: true,
      success: function (response) { console.log(response); showSuccessModal(formData); document.getElementById(formId).reset(); },
      error: function (response) { console.log(response); showErrorModal(); },
    });
    $('#' + formId).find('.is-valid').removeClass('is-valid');
  }
}

function postToSubscription(subFormData, subFormId) {
  $.ajax({
    type: 'POST',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    url: '/tr/book-SaveSubscriptionRequest',
    data: subFormData,
    crossDomain: true,
    success: function (res) {
      console.log(res);
      $('#responseSubscribeModal .modal-title').addClass('d-none');
      $('#responseSubscribeModal .modal-title.success').removeClass('d-none');
      $('#responseSubscribeModal').modal('show');
      $('#responseSubscribeModal').show();
      $('#responseSuccess').removeClass('d-none');
      $('#responseFail').addClass('d-none');
      document.getElementById('subscribeForm').reset();
      /*        
        $('#responseModal').modal('show');
        $('#responseModal').show();
        $('#responseSuccess').removeClass('d-none');
        $('#responseFail').addClass('d-none');
        document.getElementById("subscribeForm").reset();
      */
    },
    error: function (res) {
      console.log(res);
      $('#responseSubscribeModal').modal('show');
      $('#responseSubscribeModal').show();
      $('#responseSuccess').addClass('d-none');
      $('#responseFail').removeClass('d-none');
      /* 
        $('#responseModal').modal('show');
        $('#responseModal').show();
        $('#responseSuccess').addClass('d-none');
        $('#responseFail').removeClass('d-none');
      */
    },
  });
  $('#subscribeForm').find('.is-valid').removeClass('is-valid');
}

function saveRoyalty() {
  var formMemberToken = $('input[name=__RequestVerificationToken]').val();
  var royaltyFormData = {
    Name: $('input[name=memberName]').val(),
    Surname: $('input[name=memberSurname]').val(),
    BirthDate: $('input[name=memberBirthDate]').val(),
    RoyaltyCardType: $('select[name=memberRoyaltyCardType]').val(),
    RoyaltyCardNo: $('input[name=memberCardNumber]').val(),
    Email: $('input[name=memberEmail]').val(),
    HotelFidelioCode: $('select[name=memberHotelFidelioCode]').val(),
    Note: $('textarea[name=memberNote]').val(),
    LangCode: $('html').prop('lang'),
    QuestionAndBulletin: $('input[name=memberQuestionAndBulletin]:checked').val(),
    ChainId: '2',
    DomainAddress: window.location.href,
    g_recaptcha_response:$('#hotelMemberForm').find('[id*="g-recaptcha"]').val(),
  };

  $.ajax({
    type: 'POST',
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    url: '/tr/book-RoyaltyMemberSave',
    data: royaltyFormData,
    crossDomain: true,
    success: function (response) { console.log(response); showSuccessModal(); document.getElementById('hotelMemberForm').reset(); },
    error: function (response) { console.log(response); showErrorModal(); },
  });

  $('#hotelMemberForm').find('.is-valid').removeClass('is-valid');
}

function VoyageMemberCardSelect() {
  var CardValue = $('select[name=memberRoyaltyCardType]').val();
  if (CardValue == '1' || CardValue == '') {
    $('input[name=memberCardNumber]').removeAttr('required');
    $('input[name=memberCardNumber]').attr('disabled', 'disabled');
    $('input[name=memberCardNumber]').removeClass('is-invalid');
  } else {
    $('input[name=memberCardNumber]').removeAttr('disabled');
    $('input[name=memberCardNumber]').attr('required', 'true');
  }
}

document.addEventListener('currentHotel', (e) => {
  console.debug('`currentHotel` is ready:', currentHotel);

  $(`[data-value='${currentHotel?.id}']`).addClass('selected');
  var hotelname = $(`[data-value='${currentHotel?.id}']`).text();
  $('#hotelSelectddl').text(hotelname);
  $('#inpHotelId').val(currentHotel?.id);
  
  /* callReqForm btn */
  $('#btnHotelSelectionTrigger').val(currentHotel?.code);
  
});

$.validator.setDefaults({
  submitHandler: function (frm) {
    var $frm = $(frm);
    console.debug(`submitHandler:::`, frm, $frm)
    if ($frm.attr('id') === 'searchForm') {
      /* Use ExternalSearch(); */ // useLoadingEffect(); frm.submit();
      let params = Object.fromEntries(new FormData(document.forms.searchForm));
      ExternalSearch(params, '_blank');
      /* Stop the form submit process */ return false;

    } else if ($frm.attr('id') === 'callReqForm') {
      if (validateForm({ id: "callReqForm" })) {
        useSendingEffect({
          btnId: '#SendCallUsBtn',
          delay: 2500,
          callback: function () {
            var callusformid = $frm.attr('id');
            var callusformdata = {
              HotelCode: $('#btnHotelSelectionTrigger').val(),
              Country: $('#ddlCountrySelect option:selected').data('country') + ' (' + $('#ddlCountrySelect option:selected').val() + ')',
              FirstName: $('#staticNameSurname').val(),
              LastName: $('#staticLastName').val(),
              Email: $('#staticEmail').val(),
              PhoneCountryCode: $('#ddlCountrySelect').val(),
              Phone: $('#staticPhoneNo').val(),
              RequestReason: $('#btnRequestReasonTrigger').val(),
              Description: $('#complaintAndSuggestion').val(),
              CallDateHour: $('#btnCallHoursTrigger option:selected').text(),
              HotelGroup: currentHotel?.group,
              g_recaptcha_response: $frm.find('[id*="g-recaptcha"]').val(),
            };
            $('#callYouModal').modal('hide');
            postToCrm(callusformdata, callusformid);
            contactUsDataLayerTrigger();
          },
        });
      }
    } else if ($frm.attr('id') === 'subscribeForm') {
      if (validateForm({ id: "subscribeForm" })) {
        var subscribeFormId = $frm.attr('id');
        var subscribeFormData = {
          Name: $('#staticName').val(),
          LastName: $('#staticSurname').val(),
          Email: $('#staticsubEmail').val(),
          Language: $('#selectLanguage').val(),
          ChainId: '2',
          DomainAddress: window.location.href,
          g_recaptcha_response: $('#subscribeForm').find('[id*="g-recaptcha"]').val(),
        };
        $('#subscribeModal').hide();
        $('.modal-backdrop').hide();
        postToSubscription(subscribeFormData, subscribeFormId);
      }
    } else if ($frm.attr('id') === 'contactform') {
      var contactformid = $frm.attr('id');
      var contactformdata = {
        HotelCode: currentHotel?.code,
        Country: $('#ddlCountrySelectContact').val(),
        FirstName: $('#contactNameSurname').val(),
        LastName: $('#contactLastName').val(),
        Email: $('#contactEmail').val(),
        PhoneCountryCode: $('#ddlCountrySelectContact').val(),
        Phone: $('#contactStaticPhoneNo').val().replace(' ', ''),
        RequestReason: $('#contactBtnRequestReasonTrigger').val(),
        CallDateHour: $('#contactBtnCallHoursTrigger').val(),
        HotelGroup: currentHotel?.group,
        g_recaptcha_response: $frm.find('[id*="g-recaptcha"]').val(),
        // description: $('#txtnotes').val(),
      };
      postToCrm(contactformdata, contactformid);
    } else if ($frm.attr('id') === 'hotelMemberForm') {
      useSendingEffect({ btnId: '#memberFormSubmit', delay: 2500, callback: function () { saveRoyalty(); }, });
    } else { frm.submit(); }
  },
});

$('#callReqForm').validate({
  rules: {
    staticNameSurname: 'required',
    staticLastName: 'required',
    staticPhoneNo: 'required',
    staticEmail: {
      required: true,
      email: true,
    },
    customControlAutosizing: 'required',
  },
  //messages: {
  //	staticnamesurname: " ",
  //		staticphoneno: " ",
  //	staticemail: " ",
  //	customcontrolautosizing: " "
  //},
  errorElement: 'em',
  errorPlacement: function (error, element) {
    // Add the `invalid-feedback` class to the error element
    error.addClass('invalid-feedback');

    //if ( element.prop( "type" ) === "checkbox" ) {
    //	error.insertAfter( element.next( "label" ) );
    //} else {
    //	error.insertAfter( element );
    //}
  },
  highlight: function (element, errorClass, validClass) {
    $(element).addClass('is-invalid').removeClass('is-valid');
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).addClass('is-valid').removeClass('is-invalid');
  },
});
$('#hotelMemberForm').validate({
  rules: {
    memberName: 'required',
    memberSurname: 'required',
    memberBirthDate: 'required',
    memberRoyaltyCardType: 'required',
    memberEmail: {
      required: true,
      email: true,
    },
    memberHotelFidelioCode: 'required',
    memberNote: 'required',
    memberAcceptSubscribeRule: 'required',
  },
  //messages: {
  //	staticnamesurname: " ",
  //		staticphoneno: " ",
  //	staticemail: " ",
  //	customcontrolautosizing: " "
  //},
  errorElement: 'em',
  errorPlacement: function (error, element) {
    // Add the `invalid-feedback` class to the error element
    error.addClass('invalid-feedback');

    //if ( element.prop( "type" ) === "checkbox" ) {
    //	error.insertAfter( element.next( "label" ) );
    //} else {
    //	error.insertAfter( element );
    //}
  },
  highlight: function (element, errorClass, validClass) {
    $(element).addClass('is-invalid').removeClass('is-valid');
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).addClass('is-valid').removeClass('is-invalid');
  },
});
$('#subscribeForm').validate({
  rules: {
    staticsubEmail: {
      required: true,
      email: true,
    },
    staticEmailAgain: {
      required: true,
      email: true,
      equalTo: '#staticsubEmail',
    },
    staticName: 'required',
    staticSurname: 'required',
    selectLanguage: 'required',
    pipaAuthorize: 'required',
  },
  //messages: {
  //	staticnamesurname: " ",
  //		staticphoneno: " ",
  //	staticemail: " ",
  //	customcontrolautosizing: " "
  //},
  errorElement: 'em',
  errorPlacement: function (error, element) {
    // Add the `invalid-feedback` class to the error element
    error.addClass('invalid-feedback');

    //if ( element.prop( "type" ) === "checkbox" ) {
    //	error.insertAfter( element.next( "label" ) );
    //} else {
    //	error.insertAfter( element );
    //}
  },
  highlight: function (element, errorClass, validClass) {
    $(element).addClass('is-invalid').removeClass('is-valid');
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).addClass('is-valid').removeClass('is-invalid');
  },
});
$('#contactForm').validate({
  rules: {
    contactNameSurname: 'required',
    contactLastName: 'required',
    contactStaticPhoneNo: 'required',
    contactBtnRequestReasonTrigger: 'required',
    contactbtncallhourstrigger: 'required',
    contactEmail: {
      required: true,
      email: true,
    },
    chkKVKK: 'required',
  },
  //messages: {
  //	staticnamesurname: " ",
  //		staticphoneno: " ",
  //	staticemail: " ",
  //	customcontrolautosizing: " "
  //},
  errorElement: 'em',
  errorPlacement: function (error, element) {
    // Add the `invalid-feedback` class to the error element
    error.addClass('invalid-feedback');

    //if ( element.prop( "type" ) === "checkbox" ) {
    //	error.insertAfter( element.next( "label" ) );
    //} else {
    //	error.insertAfter( element );
    //}
  },
  highlight: function (element, errorClass, validClass) {
    $(element).addClass('is-invalid').removeClass('is-valid');
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).addClass('is-valid').removeClass('is-invalid');
  },
});
$('#subscribeModal').on('shown.bs.modal', function () { $('#selectLanguage').val($('html').attr('lang').toUpperCase()); });
// #endregion FORMS

// #region Flight or Availability Not Found Start
var searchWrapper = document.getElementsByClassName('search-wrapper')[0];
var searchBox = document.getElementsByClassName('search-box')[0];
var newSearch = document.getElementById('newSearch');
if (newSearch) {
  newSearch.addEventListener('click', function (e) {
    if(!$(searchBox).hasClass("expanded")) { $(searchBox).addClass("expanded") }
    if(!$(searchWrapper).hasClass("is-shown")) { $(searchWrapper).addClass("is-shown") }
    $('#base-datepickers').data('dateRangePicker').open();
    e.preventDefault();
    e.stopPropagation();
  });
}

document.querySelectorAll('#continueWithoutFlight').forEach(x => {
  x.addEventListener('click', function () {
    var flightCheckbox = document.getElementById('chkFlightSelect');
    flightCheckbox.checked = false;
    flightCheckbox.value = false;
    $('#searchForm').validate();
    $('#searchForm').submit();
  });
});
// #endregion Flight or Availability Not Found End

// $('.phoneNumber').mask('000 000 00 00');

//Hide reservation button after search if success
(function () {
  if (document.body.dataset.inm == 'False') { $("#btnReservationTrigger").addClass("d-none"); }
})();

/**
 * Retrieves the reservation details transfers.
 * @returns {Array} An array containing the reservation details transfers.
 */
 const getReservationDetailsTransfers = () => {
  return [
    document.getElementsByClassName("js-reservation-details__transfers")[0],
    document.getElementsByClassName("js-reservation-details__transfers-arrival")[0],
    document.getElementsByClassName("js-reservation-details__transfers-departure")[0]
  ];
}

/**
 * Removes the reservation details transfers based on the transfer type.
 * @param {string} transferType - The type of transfer ('arrival' or 'departure').
 */
function removeReservationDetailsTransfers(transferType) {
  const [reservationDetailsTransfers, reservationDetailsTransfersArrival, reservationDetailsTransfersDeparture] = getReservationDetailsTransfers();

  // If either the arrival or departure transfer is missing, remove the reservation details transfers.
  if (!reservationDetailsTransfersArrival || !reservationDetailsTransfersDeparture) {
    reservationDetailsTransfers.remove();
  } else {
    // Remove the specific transfer type if provided.
    if (transferType === 'arrival') { reservationDetailsTransfersArrival.remove(); }
    if (transferType === 'departure') { reservationDetailsTransfersDeparture.remove(); }
  }
}

/**
 * Disables ECO arrival.
 * @param {ValidityState} validity - Validity state object
 */
function disableEcoArrival(validity) {
  const noArrival = document.querySelectorAll(".js-transfers__no-arrival");
  const ecoArrivalInputs = document.querySelectorAll('.js-transfers__arrival-eco');
  const ecoArrivalListItems = document.querySelectorAll('.js-transfers__list-item-arrival-eco');

  for (const input of ecoArrivalInputs) {
    // If validity is invalid and the input is checked, reset the selection.
    if (!validity.valid && input.checked === true) {
      input.checked = false;
      noArrival[0].checked = true;
      // Remove the reservation details transfers for arrival.
      removeReservationDetailsTransfers("arrival");
    }

    input.disabled = !validity.valid;
  }

  for (const item of ecoArrivalListItems) {
    // Enable or disable the list items based on the validity state.
    if (validity.valid) {
      item.classList.remove("transfers__list-item--disabled");
    } else {
      item.classList.add("transfers__list-item--disabled");
    }
  }
}

/**
 * Disables ECO departure.
 * @param {ValidityState} validity - Validity state object
 */
function disableEcoDeparture(validity) {
  const noDeparture = document.querySelectorAll(".js-transfers__no-departure");
  const ecoDepartureInputs = document.querySelectorAll('.js-transfers__departure-eco');
  const ecoDepartureListItems = document.querySelectorAll('.js-transfers__list-item-departure-eco');

  for (const input of ecoDepartureInputs) {
    // If validity is invalid and the input is checked, reset the selection.
    if (!validity.valid && input.checked === true) {
      input.checked = false;
      noDeparture[0].checked = true;
      // Remove the reservation details transfers for departure.
      removeReservationDetailsTransfers("departure");
    }

    input.disabled = !validity.valid;
  }

  for (const item of ecoDepartureListItems) {
    // Enable or disable the list items based on the validity state.
    if (validity.valid) {
      item.classList.remove("transfers__list-item--disabled");
    } else {
      item.classList.add("transfers__list-item--disabled");
    }
  }
}